import dynamic from 'next/dynamic';
import { memo } from 'react';

import { useEditModeBoundingBox } from '~/components/EditMode/hooks/useEditModeBoundingBox';

export { MoveMode, RefocusMode, SelectionMode } from '~/components/EditMode/components/BoundingBoxLayerKonva/types';

// Dynamic import to avoid SSR issues with react-konva
const EditModeBoundingBoxContent = dynamic(
  () =>
    import('~/components/EditMode/components/EditModeBoundingBox/EditModeBoundingBoxContent').then(
      (mod) => mod.EditModeBoundingBoxContent,
    ),
  { ssr: false },
);

export type EditModeBoundingBoxProps = {
  enableContainerMouseEvents: (enable: boolean) => void;
  className?: string;
  isVisible?: boolean;
};

export const EditModeBoundingBox = memo(
  ({ enableContainerMouseEvents, className, isVisible = true }: EditModeBoundingBoxProps) => {
    const {
      boundingBox: { containerDimensions },
    } = useEditModeBoundingBox();

    if (!isVisible || !containerDimensions) {
      return null;
    }

    const { containerWidth, containerHeight } = containerDimensions;

    return (
      <EditModeBoundingBoxContent
        containerWidth={containerWidth}
        containerHeight={containerHeight}
        enableContainerMouseEvents={enableContainerMouseEvents}
        className={className}
      />
    );
  },
);

EditModeBoundingBox.displayName = 'EditModeBoundingBox';
